import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RechnungValidierenSectionHeadersWhitePattern2 from '../components/headers-white-pattern/RechnungValidierenSectionHeadersWhitePattern2';
import RechnungValidierenSectionApplicationsWhitePattern6 from '../components/applications-white-pattern/RechnungValidierenSectionApplicationsWhitePattern6';
import RechnungValidierenSectionContactsWhitePattern4 from '../components/contacts-white-pattern/RechnungValidierenSectionContactsWhitePattern4';
import RechnungValidierenSectionTestimonialsWhitePattern7 from '../components/testimonials-white-pattern/RechnungValidierenSectionTestimonialsWhitePattern7';
import RechnungValidierenSectionFootersGrayPattern5 from '../components/footers-gray-pattern/RechnungValidierenSectionFootersGrayPattern5';

const meta = {
  title: 'Rechnungen\u0020validieren',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function RechnungValidieren() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <RechnungValidierenSectionHeadersWhitePattern2 />
      <RechnungValidierenSectionApplicationsWhitePattern6 />
      <RechnungValidierenSectionContactsWhitePattern4 />
      <RechnungValidierenSectionTestimonialsWhitePattern7 />
      <RechnungValidierenSectionFootersGrayPattern5 />
    </React.Fragment>
  );
}

